<template>
  <div class="dropdown" :class="{ 'dropdown--open': opened }">
    <div
        class="value"
        @click="opened = !opened"
        :class="{ 'value--opened': opened }"
    >
      <div class="value-label">{{ label }}</div>
      <div class="list" v-if="opened">
        <ul>
          <li
              v-for="option in options"
              :key="option.code"
              class="option"
              :class="optionClass(option)"
              @click="option.count && $emit('input', option.code)"
          >
            <span>{{ option.name }}</span>
            <span class="count" v-if="option.count">{{ option.count }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Выберите федеральный округ',
    },
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      opened: false
    };
  },
  computed: {
    label() {
      return this.value
          ? this.options.find(option => option.code === this.value).name
          : this.placeholder;
    }
  },
  watch: {
    opened(state) {
      state
          ? document.body.addEventListener("click", this.close)
          : document.body.removeEventListener("click", this.close);
    }
  },
  methods: {
    close($e) {
      if (!$e || !this.$el.contains($e.target)) {
        this.opened = false;
      }
    },
    optionClass(option) {
      return {
        "option--selected": option.code === this.value,
        "option--active": option.count > 0
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  max-width: 320px;
  width: 100%;

  user-select: none;
  * {
    user-select: none;
  }

  &.dropdown--open {
    z-index: 90;
  }

  @media (max-width: 767px) {
    //background: #f3f3f3;
    //border-radius: 32px 32px 0 0;
    //padding: 10px 10px 42px;

    //&:after {
    //  content: "";
    //  position: absolute;
    //  right: 0;
    //  left: 0;
    //  bottom: 0;
    //  background: #fff;
    //  height: 32px;
    //  border-radius: 32px 32px 0 0;
    //}

    max-width: 320px;
    width: 100%;

  }
}
.value {
  background: #fff;
  font-size: 16px;
  border-radius: 100px;
  box-shadow: 0px 3px 6px rgba(#000, 0.16);
  position: relative;
  display: inline-block;
  cursor: pointer;

  max-width: 320px;
  width: 100%;

  @media (max-width: 767px) {
    min-width: 100%;
    width: 100%;
  }

  &--opened {
    &:after {
      transform: rotate(-180deg) translate(0, 2px);
    }
  }

  &-label {
    height: 50px;
    line-height: 42px;
    padding: 0 60px 0 20px;
    position: relative;
    z-index: 2;
    border-radius: 50px;
    border: 4px solid #fff;
    transition: all 0.2s;

    .value---opened & {
      background: #f0f0f0;
    }
  }

  &:before {
    content: "";
    position: absolute;
    right: 4px;
    top: 4px;
    box-shadow: 0px 3px 6px rgba(#000, 0.16);
    width: 42px;
    height: 42px;
    border-radius: 42px;
    background: linear-gradient(#719fef 0%, #4679d2 100%);
    z-index: 3;
  }
  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: 8px solid #fff;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    right: 20px;
    top: 22px;
    z-index: 4;
    transition: all 0.2s;
  }
}
.list {
  position: absolute;
  background: #fff;
  left: 0;
  right: 0;
  top: 25px;
  border-radius: 0 0 25px 25px;
  box-shadow: 0px 3px 6px rgba(#000, 0.16);
  padding: 25px 12px 15px;

  .option {
    padding: 8px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #999;

    &--active {
      color: #3a3a3a;
    }
    &--selected {
      background: linear-gradient(#719fef 0%, #4679d2 100%);
      border-top-color: #719fef;
      color: #fff;
      border-radius: 25px;

      + li {
        border-top-color: transparent;
      }
    }

    &:first-child {
      border-top: none;
    }
    .count {
      background: #f0f0f0;
      border-radius: 50%;
      font-size: 14px;
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      color: #333;
    }
  }
}
</style>
